var render, staticRenderFns
import script from "./ProcessTree.vue?vue&type=script&lang=js"
export * from "./ProcessTree.vue?vue&type=script&lang=js"
import style0 from "./ProcessTree.vue?vue&type=style&index=0&id=8fe3c82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe3c82e",
  null
  
)

export default component.exports